import { ComponentChildren } from 'preact';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ComponentChildren;
  maxWidthClass?: string;
}

export function Modal({ isOpen, onClose, children, maxWidthClass = 'max-w-md' }: ModalProps) {
  if (!isOpen) return null;

  return (
    <div class="modal-backdrop">
      <div class="fixed inset-0" onClick={onClose} />
      <div class={`modal-dialog ${maxWidthClass}`}>
        {children}
      </div>
    </div>
  );
}
